//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025, 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/**
 * Extract loop context from URL query parameters
 * Used by embedded apps to read loop context passed from the switcher
 */
export const getLoopContextFromQueryParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const loopId = searchParams.get('loopId');
  const loopName = searchParams.get('loopName');
  const teamspaceId = searchParams.get('teamspaceId');

  return {
    teamspaceId: teamspaceId ?? null,
    loopId: loopId ?? null,
    loopName: loopName ?? null,
    isLoopContextActive: loopId !== null && loopName !== null,
  };
};

/**
 * Build URL with loop context query parameters
 * Used by switcher to propagate loop context to target app
 */
export const buildUrlWithLoopContext = (
  baseUrl: string,
  teamspaceId: string,
  loopId?: string | null,
  loopName?: string | null,
): string => {
  if (!teamspaceId) return baseUrl;

  const isAbsolute = /^https?:\/\//i.test(baseUrl);
  const url = new URL(baseUrl, window.location.origin);
  url.searchParams.set('teamspaceId', teamspaceId);
  if (loopId && loopName) {
    url.searchParams.set('loopId', loopId);
    url.searchParams.set('loopName', loopName);
  }
  // Return a relative path when the input was relative, so callers that
  // prepend the origin themselves don't end up with a double-origin URL.
  return isAbsolute
    ? url.toString()
    : `${url.pathname}${url.search}${url.hash}`;
};
